import { render, staticRenderFns } from "./TradePanel.vue?vue&type=template&id=7c7651f6&scoped=true"
import script from "./TradePanel.vue?vue&type=script&lang=js"
export * from "./TradePanel.vue?vue&type=script&lang=js"
import style0 from "./TradePanel.vue?vue&type=style&index=0&id=7c7651f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7651f6",
  null
  
)

export default component.exports